import React, { useLayoutEffect, useContext } from 'react';
import { MessageContext } from '../../context/MessageContext';
import { createTheme, ThemeProvider } from '@mui/material';
import Footer from './Footer';
import Header from './Header';
import Accueil from '../../views/Accueil/Accueil';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { logError } from '../Utils/FormatData';
import useAuthz from '../../hooks/useAuthz';

const Layout = (props) => {
  const [authz, user, profil] = useAuthz();
  const { params, contenu, title, route } = props;
  const Component = props.component;
  const { markMessagesAsRead } = useContext(MessageContext);
  const contenuRef = React.createRef();

  let theme = createTheme({
    typography: {
      fontFamily: ['Gadugi', 'sans-serif'].join(','),
      fontWeightMedium: 500,
      h6: {
        fontSize: 25,
        marginLeft: 25,
      },
      caption: {
        fontSize: 10,
        marginLeft: 25,
        marginTop: 10,
      },
      subtitle1: {
        fontSize: 12,
      },
    },
    palette: {
      primary: {
        main: '#0094ca',
      },
      secondary: {
        main: '#0094ca',
      },
      success: {
        main: '#a5c946',
      },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: '0px 6px 3px -3px #00000033, 0px 3px 3px 0px #00000024, 0px 3px 9px 0px #0000001f',
            borderRadius: '10px',
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            fontWeight: 'bold',
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            padding: '16px 0',
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            margin: '20px',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontSize: '14px',
            color: '#323c46',
            height: '40px !important',
            padding: '0 15px',
            border: '1px solid #e0e0e0',
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            width: '100%',
          },
        },
      },
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            padding: 0,
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            height: '100%',
          },
        },
      },
      MuiButtonBase: {
        styleOverrides: {
          root: {
            padding: '9px'
          },
        },
      }
    },
  });

  useLayoutEffect(() => {
    markMessagesAsRead(user);
  }, [route]);

  return (
    <div>
      <ThemeProvider theme={theme}>
        <div className='layout-container'>
          <div id='filtre-rose' />
          <Header />
          {
            route?.path !== '/accueil' && route !== '/' &&
            <div className='card-contenu' ref={contenuRef}>
              <Component title={title} contenu={contenu} route={route} contenuRef={contenuRef} params={params} />
            </div>
          }
          <Accueil />
          <Footer />
        </div>
      </ThemeProvider>
    </div>
  );
};

export default Layout;